import { getActionFromUrl } from "./initializer";
import { luscinia } from "./luscinia";

luscinia.renderParameter = function (parameterFullName, paramData, allowNullValues) {
    let url = "/parameter/render/" + parameterFullName;
    if (allowNullValues !== undefined) {
        url += "?allowNullValues=" + allowNullValues;
    }
    $.ajax({
        method: "Post",
        url: url,
        data: paramData,
        success: function (data) {
            var contentSelector = luscinia.parameter.identifier.parameterContent;
            $(contentSelector).replaceWith(data);
            var form = $(contentSelector).closest("form");
            luscinia.initFormElements(form, $(contentSelector)).then(function () {
                 var formData = luscinia.serializeFormObject($(form));
                 $.ajax({
                     method: "POST",
                     processData: false,
                     contentType: false,
                     url: "/parameter/afteropen/" + parameterFullName,
                     data: formData
                 }).done(function (actions) {
                     luscinia.executeActionList(actions, form, false);
                 });
            });
        }
    });
};

luscinia.renderEmailParameter = function (parameterFullName, urlExtension?: string) {
    const url = `/parameter/email/${luscinia.getModalLayerCount()}/${parameterFullName}` + urlExtension ?? "";
    $.get(url, function (data) {
        $("#cl-wrapper").append(data);
        
        var form = luscinia.getActiveForm();
        var modal = luscinia.getCurrentModal();
        var modalIdentifier = "#" + modal.attr("id");
        luscinia.initModalDialog(form, modalIdentifier, luscinia.config, getActionFromUrl(url), modalIdentifier).then(function () {
            var formData = luscinia.serializeFormObject(form);
            $.ajax({
                method: "POST",
                processData: false,
                contentType: false,
                url: "/parameter/afteropen/" + parameterFullName,
                data: formData
            }).done(function (actions) {
                luscinia.executeActionList(actions, form, false);
            });
        });
        $(modalIdentifier).modal("show");
    });
};

luscinia.resetPinCode = function (parameterFullName) {
    $.get(`/parameter/resetPinCode/${luscinia.getModalLayerCount()}/${parameterFullName}`, function (data) {
        var modalIdentifier = "#editModal" + luscinia.getModalLayerCount();
        $("#cl-wrapper").append(data);
        luscinia.initModalDialog($(modalIdentifier + "Form"), modalIdentifier, luscinia.config, modalIdentifier);
        $(modalIdentifier).modal("show");
    });
};